import { render, staticRenderFns } from "./AddItemsComponent.vue?vue&type=template&id=b59f2050"
import script from "./AddItemsComponent.vue?vue&type=script&lang=js"
export * from "./AddItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./AddItemsComponent.vue?vue&type=style&index=0&id=b59f2050&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b59f2050')) {
      api.createRecord('b59f2050', component.options)
    } else {
      api.reload('b59f2050', component.options)
    }
    module.hot.accept("./AddItemsComponent.vue?vue&type=template&id=b59f2050", function () {
      api.rerender('b59f2050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/components/AddItemsComponent.vue"
export default component.exports